import Paypal from './PaymentButtons/Paypal/Paypal';
// import GooglePay from './PaymentButtons/GooglePay/GooglePay';
// import ApplePay from './PaymentButtons/ApplePay/ApplePay';

const PaymentButtons = [
    // {
    //     id: 1,
    //     PaymentButton: GooglePay
    // },
    // {
    //     id: 2,
    //     PaymentButton: ApplePay
    // },
    {
        id: 3,
        PaymentButton: Paypal
    }
]

export default PaymentButtons

export const stripeAppearance = {
  theme: 'stripe',
  variables: {
    spacingUnit: '6px',
  },
  rules: {
    '.Label': {
      color: '#8C8C8C',
      fontSize: '12px',
    },
    '.Input': {
      color: '#020529',
      fontSize: '15px',
      padding: '13px',
    },
  },
};